exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/UTL/BMI/Admin/Admin-ANG/src/app/shared/peer-evaluation-grid/peer-evaluation-grid.component.css
// module id = ../../../../../src/app/shared/peer-evaluation-grid/peer-evaluation-grid.component.css
// module chunks = main